import React from 'react';
import PropTypes from 'prop-types';

import styles from './TitleMajor.module.css';

export default class TitleMajor extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
    }

    render() {
        return (
            <h1 className={styles.base}>{this.props.children}</h1>
        )
    }
}
